{
  "id": "sideTable",
  "name": "Side Table",
  "builds": "product",
  "category": "furniture",
  "note": "Every table is built upside down. Legs on end, top face-down.",
  "skill": "furnitureBasics",
  "duration": 60,
  "offeredBy": "bench",
  "fastener": "screws",
  "value": 44,
  "widthIn": 12,
  "heightIn": 24,
  "slots": [
    {
      "id": "top-0",
      "role": "top",
      "part": {
        "widthIn": 12,
        "lengthIn": 24,
        "thicknessQ": 4
      },
      "stock": {
        "type": "panel",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 6,
      "yIn": 12,
      "angleDeg": 0,
      "zIn": 0
    },
    {
      "id": "leg-0",
      "role": "leg",
      "part": {
        "widthIn": 2,
        "lengthIn": 24,
        "thicknessQ": 6
      },
      "stock": {
        "type": "board",
        "surface": "smooth",
        "thickness": [6, 8]
      },
      "xIn": 2,
      "yIn": 2.5,
      "angleDeg": 0,
      "zIn": 1,
      "onEnd": true
    },
    {
      "id": "leg-1",
      "role": "leg",
      "part": {
        "widthIn": 2,
        "lengthIn": 24,
        "thicknessQ": 6
      },
      "stock": {
        "type": "board",
        "surface": "smooth",
        "thickness": [6, 8]
      },
      "xIn": 10,
      "yIn": 2.5,
      "angleDeg": 0,
      "zIn": 1,
      "onEnd": true
    },
    {
      "id": "leg-2",
      "role": "leg",
      "part": {
        "widthIn": 2,
        "lengthIn": 24,
        "thicknessQ": 6
      },
      "stock": {
        "type": "board",
        "surface": "smooth",
        "thickness": [6, 8]
      },
      "xIn": 2,
      "yIn": 21.5,
      "angleDeg": 0,
      "zIn": 1,
      "onEnd": true
    },
    {
      "id": "leg-3",
      "role": "leg",
      "part": {
        "widthIn": 2,
        "lengthIn": 24,
        "thicknessQ": 6
      },
      "stock": {
        "type": "board",
        "surface": "smooth",
        "thickness": [6, 8]
      },
      "xIn": 10,
      "yIn": 21.5,
      "angleDeg": 0,
      "zIn": 1,
      "onEnd": true
    }
  ],
  "fasteners": [
    {
      "xIn": 2,
      "yIn": 2.5
    },
    {
      "xIn": 10,
      "yIn": 2.5
    },
    {
      "xIn": 2,
      "yIn": 21.5
    },
    {
      "xIn": 10,
      "yIn": 21.5
    }
  ]
}
